// extracted by mini-css-extract-plugin
export default {"ThumbnailContainer":"HomePage_ThumbnailContainer__apQgg","Title":"HomePage_Title__uezMV"};